import React, { FC } from "react";

interface Props {
  title: string;
  className?: string;
}

export const BlockHeader: FC<Props> = ({ title, className = "" }) => {
  return (
    <div
      className={`pl-4 font-bold leading-[30px] md:leading-[36px] text-[20px] md:text-[24px] space-y-4 md:space-y-0 md:h-auto border-l-[3px] md:border-l-[5px] border-[#41C9B4] break-word ${className}`}
    >
      {title}
    </div>
  );
};
